import React, { useEffect, useState, useMemo } from 'react';
import { useFormik } from 'formik';
import { Box, FormControl, InputLabel, MenuItem, Select, Typography, Autocomplete, TextField } from '@mui/material';
import { FormTextField } from '../shared/FormTextField';
import { SubmitButtonForm } from '../shared/SubmitButtonForm';
import { updateDevice, fetchDeviceData, fetchDeviceData2, updateAddr } from "../../Api/DevicesApi";
import s from "./DeviceInfo.module.css";
import { brandIoT, typeDevice, typeIoT, typeResourse } from '../../constants/constants';
import { FormSelect } from '../shared/FormSelect';
import { ModalTemplate } from "../shared/ModalForms";
import { getAddressByGroupId } from 'Api/AddressApi';
import { AddressFormGroup } from 'Components/Forms/AddressForm';


export const DeviceEditForm = ({ deviceId, closeModal, setAlertInfo, setOpen }) => {

    const [initialValues, setInitialValues] = useState({
        device_iot: { dev_type_iot: '', brand_iot: '', module_number: '', token: '', manufacture: '' },
        device: { dev_type: '', dev_number: '', resourse_type: '', brand: '', diameter_body: '', commit: '', verification_end_date: '', factor: '' },
        paid_info: { dev_number: '', registry: '', ownership: '', devicecode: '', accountnumber: '', subscriptionarea: '' },
        start_volume: 0.0,
        chanel: null
    });


    useEffect(() => {
        const fetchData = async () => {
            const response = await fetchDeviceData(deviceId);
            setInitialValues({
                device_iot: response.device_iot,
                device: response.device,
                paid_info: response.paid_info,
                start_volume: response.data.start_volume,
                chanel: response.chanel
            });
        };
        fetchData();
    }, [deviceId]);

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: async (values, { setSubmitting }) => {
            setSubmitting(true);
            try {
                const data = await updateDevice(deviceId, values);
                setAlertInfo({ severity: 'success', message: data.message });
                setOpen(true);
                closeModal();
            } catch (error) {
                const message = error?.response?.data?.detail || error?.message
                setAlertInfo({ severity: 'error', message: message });
                setOpen(true);
            }
        },
        enableReinitialize: true,
    })

    console.log(formik.values);
    

    const handleFormClick = (event) => {
        event.stopPropagation();
    };

    return (
        <div className={s.editContainer}>
            <form onSubmit={formik.handleSubmit} onClick={handleFormClick}>
                <div className={s.grid}>
                    <Box sx={{ width: "auto", flex: 1 }}>
                        <Typography variant="h5">IoT Устройство</Typography>
                        <FormControl required fullWidth sx={{ marginTop: 2 }}>
                            <InputLabel>Тип устройства</InputLabel>
                            <FormSelect formik={formik} name={"device_iot.dev_type_iot"} value={formik.values.device_iot.dev_type_iot} label={"Тип устройства"}>
                                {typeIoT.map((type) => (
                                    <MenuItem key={type} value={type}>
                                        {type}
                                    </MenuItem>
                                ))}
                            </FormSelect>
                        </FormControl>
                        <FormControl required fullWidth sx={{ marginTop: 2 }}>
                            <InputLabel>Тип связи</InputLabel>
                            <FormSelect formik={formik} name={"device_iot.brand_iot"} value={formik.values.device_iot.brand_iot} label={"Тип связи"}>
                                {brandIoT.map((type) => (
                                    <MenuItem key={type} value={type}>
                                        {type}
                                    </MenuItem>
                                ))}
                            </FormSelect>
                        </FormControl>
                        <FormTextField formik={formik} name={"device_iot.module_number"} value={formik.values.device_iot.module_number} label={"Заводской номер модуля"} />
                        <FormTextField formik={formik} name={"device_iot.token"} value={formik.values.device_iot.token} label={"Токен"} />
                        <FormTextField formik={formik} name={"device_iot.manufacture"} value={formik.values.device_iot.manufacture} label={"Производитель устройства"} />
                    </Box>
                    <Box sx={{ width: "auto", flex: 1 }}>
                        <Typography variant="h5">Устройство</Typography>
                        <FormControl required fullWidth sx={{ mt: 2 }}>
                            <InputLabel>Тип устройства</InputLabel>
                            <FormSelect formik={formik} name={"device.dev_type"} value={formik.values.device.dev_type} label={"Тип устройства"}>
                                {typeDevice.map(({ key, label }) => (
                                    <MenuItem key={key} value={key}>
                                        {label}
                                    </MenuItem>
                                ))}
                            </FormSelect>
                        </FormControl>
                        <FormTextField formik={formik} name={"device.dev_number"} value={formik.values.device.dev_number} label={"Заводской номер"} />
                        <FormControl fullWidth sx={{ mt: 2 }}>
                            <InputLabel id="resource-type-label">Тип ресурса</InputLabel>
                            <FormSelect formik={formik} name={"device.resourse_type"} value={formik.values.device.resourse_type} label={"Тип ресурса"}>
                                {typeResourse.map((option) => (
                                    <MenuItem key={option} value={option}>{option}</MenuItem>
                                ))}
                            </FormSelect>
                        </FormControl>
                        <FormTextField formik={formik} name={"device.brand"} value={formik.values.device.brand} label={"Марка"} />
                        <FormTextField formik={formik} name={"device.diameter_body"} value={formik.values.device.diameter_body} label={"Диаметр устройства"} />
                        <FormTextField formik={formik} name={"device.commit"} value={formik.values.device.commit} label={"Комментарий"} />
                        <FormTextField formik={formik} name={"device.verification_end_date"} value={formik.values.device.verification_end_date} label={"Дата окончания поверки"} />
                        <FormTextField formik={formik} name={"device.factor"} value={formik.values.device.factor} label={"Множитель"} />
                        <FormTextField formik={formik} name={"start_volume"} value={formik.values.start_volume} label={"Начальные показания"} />
                    </Box>
                    <Box sx={{ width: "auto", flex: 1 }}>
                        <Typography variant="h5">Платежная Информация</Typography>
                        <FormTextField formik={formik} name={"paid_info.registry"} value={formik.values.paid_info.registry} label={"Реестр"} />
                        <FormTextField formik={formik} name={"paid_info.ownership"} value={formik.values.paid_info.ownership} label={"Владелец"} />
                        <FormTextField formik={formik} name={"paid_info.devicecode"} value={formik.values.paid_info.devicecode} label={"Код устройства в ЕРИП"} />
                        <FormTextField formik={formik} name={"paid_info.accountnumber"} value={formik.values.paid_info.accountnumber} label={"Лицевой счет"} />
                        <FormTextField formik={formik} name={"paid_info.subscriptionarea"} value={formik.values.paid_info.subscriptionarea} label={"Абонентский район"} />
                    </Box>
                </div>
                <SubmitButtonForm>Отправить</SubmitButtonForm>
            </form>
        </div>
    );
}


export const DeviceAddrEditForm = ({ deviceInfo, deviceId, closeModal, setAlertInfo, setOpen }) => {

    const [addressList, setAddressList] = useState([]);
    const [addNew, setAddNew] = useState(false);

    const [formData, setFormData] = useState({
        address: deviceInfo.addressId,
        address_number: deviceInfo.addressNumber,
        device_id: deviceId,
    })

    const [openGroup, setOpenGroup] = useState(false);
    const handleOpenGroup = () => setOpenGroup(true);
    const handleCloseGroup = () => setOpenGroup(false);

    const [openAddress, setOpenAddress] = useState(false);
    const handleOpenAddress = () => setOpenAddress(true);
    const handleCloseAddress = () => setOpenAddress(false);

    const handleChange = (field) => (e) => {
        setFormData({ ...formData, [field]: e.target.value });
    };

    const handleCancel = () => {
        setFormData({
            address: "",
            address_number: "",
            device_id: "",
        })
    }

    const handleChangeAddr = async () => {
        try {
            const res = await updateAddr(formData)
            if (res.status === 200) {
                console.log("Устройство успешно обновлено:", res.data);
                const message = res.data?.message || "Изменение адреса успешно";
                setAlertInfo({ severity: 'success', message: message });
                handleCancel();
                setOpen(true);
                closeModal();
            }
            else {
                console.error("Ошибка при обновлении устройства:", res);
                const message = res.data?.message || "Ошибка при изменении адреса";
                setAlertInfo({ severity: 'error', message: message });
                setOpen(true);
            }
        } catch (error) {
            console.error("Ошибка при обновлении устройства:", error);
            const message = error?.response?.data?.detail || error?.message || "Ошибка при изменении адреса";
            setAlertInfo({ severity: 'error', message: message });
            setOpen(true);
        }
    }

    const handleAddressSuccess = (newAddress) => {
        setAddNew(true);
        handleChange('address');
        handleCloseAddress();
    };

    useEffect(() => {
        async function fetchAddress() {
            try {

                const data = await getAddressByGroupId(deviceInfo.group);
                setAddressList(data);
                return;



            } catch (error) {
                console.error('Error fetching address list:', error.message);
            }
        }

        fetchAddress();

    }, [deviceInfo, addNew]);

    const selectedAddress = useMemo(() => {
        if (!Array.isArray(addressList) || !formData.address) {
            console.log('Address not found - addressList:', addressList, 'formData.address:', formData.address);
            return null;
        }
        const found = addressList.find(addr => {
            const addrId = String(addr._id);
            const formId = String(formData.address);
            const matches = addrId === formId;
            if (matches) {
                console.log('Address found:', addr);
            }
            return matches;
        });
        if (!found) {
            console.log('Address not found in list. formData.address:', formData.address, 'Available IDs:', addressList.map(a => String(a._id)));
        }
        return found || null;
    }, [addressList, formData.address]);


    const handleFormClick = (event) => {
        event.stopPropagation();
    };

    return (
        <div className={s.editContainer}>
            <Typography variant="h5">Редактирование адреса</Typography>
            <FormControl fullWidth sx={{ marginTop: 2 }}>
                <Autocomplete
                    value={selectedAddress}
                    onChange={(event, newValue) => {
                        if (newValue && newValue._id === 'new') {
                            handleOpenAddress();
                        } else if (newValue) {
                            console.log("Сохраняем id:", newValue._id);
                            setFormData(prev => ({ ...prev, address: newValue._id }));
                        } else {
                            console.log("Очищаем адрес");
                            setFormData(prev => ({ ...prev, address: "" }));
                        }
                    }}
                    freeSolo
                    options={[{ _id: 'new', label: '+ Добавить адрес' }, ...(addressList || [])]}
                    getOptionLabel={(option) =>
                        option._id === 'new' ? '' :
                            option.label || `${option.city || ''}, ${option.street || ''}, ${option.building || ''}`
                    }
                    renderInput={(params) => <TextField required {...params} label="Адрес" />}
                    renderOption={(props, option) => (
                        <li {...props} key={option._id}>
                            {option.label
                                ? option.label
                                : `${option.city || ''}, ${option.street || ''}, ${option.building || ''}`}
                        </li>
                    )}
                />

                <ModalTemplate
                    open={openAddress}
                    onClose={handleCloseAddress}
                >
                    <AddressFormGroup onSuccess={handleAddressSuccess} group={deviceInfo.group} />

                </ModalTemplate>
            </FormControl>
            <TextField fullWidth sx={{ marginTop: 2 }} label="Квартира/помещение" value={formData.address_number} onChange={handleChange("address_number")} />
            <SubmitButtonForm onClick={() => {
                handleChangeAddr();
            }}>Отправить</SubmitButtonForm>
        </div>
    )
}